module.exports = __webpack_public_path__ + "static/media/covid.23b85808.svg";